/* global axios */
import ApiClient from './ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('whatsapp_calls', { accountScoped: true });
  }

  initiate({ conversationId, sdpOffer }) {
    return axios
      .post(`${this.url}/initiate`, {
        conversation_id: conversationId,
        sdp_offer: sdpOffer,
      })
      .then(r => r.data);
  }

  accept(callId, sdpAnswer) {
    return axios
      .post(`${this.url}/${callId}/accept`, { sdp_answer: sdpAnswer })
      .then(r => r.data);
  }

  reject(callId) {
    return axios.post(`${this.url}/${callId}/reject`).then(r => r.data);
  }

  terminate(callId) {
    return axios.post(`${this.url}/${callId}/terminate`).then(r => r.data);
  }
}

export default new WhatsappCallsAPI();
